import { COMPONENT_TYPE } from 'common/constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const floatBelow = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.FLOAT_BELOW> =>
	createModel({
		type: COMPONENT_TYPE.FLOAT_BELOW,
		nodeType: 'flb',
		editorProps: {
			selectable: false,
			draggable: false,
			expandable: true,
			expanded: true,
		},
		componentProps: {
			styles: {},
			other: {},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.FLOAT_BELOW>;
